module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--business-circle-4-bddcf710.png";